import MDinput from '@/components/MDinput';
import { validatorRequireNumber, validatorRequire } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';
import Switch from '@/components/DSE/Switch';
import Select from '@/components/DSE/Select';
import ExcludedFinishesList from '../../components/ExcludedFinishesList';
import AddressInput from '@/components/DSE/AddressInput';
import TimeRangePicker from '@/components/DSE/TimeRangePicker';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, true, false, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'common.transport', 'common.excludedFinishes'],
    formLabelWidths: ['220'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        code: {
          type: InputNumber,
          defaultValue: 1,
          props: {
            min: 1,
            max: 99,
            step: 1,
            caption: 'workshop.code'
          }
        },
        stockLocationName: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            caption: 'workshop.stockLocationName',
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        companyID: {
          type: Select,
          defaultValue: '',
          props: {
            caption: 'domain.company',
            required: true,
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['company/isLoading'],
            options: vue.$store.getters['company/loadedItems']
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        panelsMaxPerSeries: {
          type: InputNumber,
          defaultValue: +vue.$store.getters['configuration/value']('workshop.panelsMaxPerSeries'),
          props: {
            caption: 'workshop.panelsMaxPerSeries'
          }
        },
        metersMaxPerSeries: {
          type: InputNumber,
          defaultValue: +vue.$store.getters['configuration/value']('workshop.metersMaxPerSeries'),
          props: {
            caption: 'workshop.metersMaxPerSeries'
          }
        },
        romanBlindsMaxPerSeries: {
          type: InputNumber,
          defaultValue: +vue.$store.getters['configuration/value']('workshop.romanBlindsMaxPerSeries'),
          props: {
            caption: 'workshop.romanBlindsMaxPerSeries'
          }
        },
        excludeHandlockYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'workshop.excludeHandlockYN'
          }
        },
        excludeExpressOrderYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'workshop.excludeExpressOrderYN'
          }
        },
        excludeSamplesYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'workshop.excludeSamplesYN'
          }
        },
        maximumProcessingHeight: {
          type: InputNumber,
          defaultValue: +vue.$store.getters['configuration/value']('workshop.maximumProcessingHeight'),
          props: {
            caption: 'workshop.maximumProcessingHeight'
          }
        },
        ignoreExcludedFabricsYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'workshop.ignoreExcludedFabrics'
          }
        },
        planningDisabledYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'workshop.planningDisabled'
          }
        },
        excludedFinishes: {
          type: ExcludedFinishesList,
          props: {
            caption: 'common.emptyString'
          }
        },
        loadingAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            caption: 'transport.loadingAddress',
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        loadingAddressCode: {
          type: MDinput,
          props: {
            maxlength: 8,
            caption: 'transport.loadingAddressCode'
          }
        },
        loadingTimeRange: {
          type: TimeRangePicker,
          props: {
            caption: 'transport.loadingTimeRange',
            format: 'hh:mm'
          }
        }
      }
    ]
  };
}

const layoutGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: [
        'name',
        'code',
        'stockLocationName',
        'companyID',
        'panelsMaxPerSeries',
        'metersMaxPerSeries',
        'romanBlindsMaxPerSeries'
      ]
    },
    {
      width: 50,
      fields: [
        'excludeHandlockYN',
        'excludeExpressOrderYN',
        'excludeSamplesYN',
        'maximumProcessingHeight',
        'ignoreExcludedFabricsYN',
        'planningDisabledYN'
      ]
    }
  ]
};

const layoutTabTransport = {
  named: true,
  sections: [
    {
      fields: ['loadingAddress', 'loadingAddressCode', 'loadingTimeRange']
    }
  ]
};
const layoutTabExcludedFinishes = {
  named: true,
  sections: [
    {
      fields: ['excludedFinishes']
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutGeneral, layoutTabTransport]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutGeneral, layoutTabTransport, layoutTabExcludedFinishes]
  };
}

export function createItemFromFormData(vue, form) {
  const item = { ...form };
  item.loadingFromTime = form.loadingTimeRange && form.loadingTimeRange.startTime;
  item.loadingUntilTime = form.loadingTimeRange && form.loadingTimeRange.endTime;
  delete item.loadingTimeRange;
  return item;
}

export function createFormDataFromItem(vue, item) {
  const form = { ...item };
  form.loadingTimeRange = {
    startTime: item.loadingFromTime,
    endTime: item.loadingUntilTime
  };
  return form;
}
